import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner, Alert, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { registerExternalUser, validateExternalUser } from '../actions/userActions';
import { useNavigate } from 'react-router-dom';

const SignupModal = ({ show, onHide }) => {

    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        email: '',
        tipoDocumento: '',
        numeroDocumento: '',
        cargosExternos: [{
            cargo: '',
            entidad: {
                nombre: '',
                cuit: '',
                rubro: '',
                pais: '',
                provincia: '',
                sitioWeb: '',
                emailContacto: '',
                telefonoContacto: ''
            }
        }]
    });
    const [hasCompany, setHasCompany] = useState(false);
    const [showVerification, setShowVerification] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, userInfo, error } = useSelector(state => state.user);

    useEffect(() => {
        if (userInfo && userInfo.authenticated !== false) {
            navigate('/backoffice');
            onHide();
        }
    }, [userInfo, navigate, onHide]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCargoChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            cargosExternos: [{
                ...prev.cargosExternos[0],
                [name]: value
            }]
        }));
    };

    const handleEntidadChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            cargosExternos: [{
                ...prev.cargosExternos[0],
                entidad: {
                    ...prev.cargosExternos[0].entidad,
                    [name]: value
                }
            }]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const dataToSend = {
            ...formData,
            cargosExternos: hasCompany ? formData.cargosExternos : []
        };
        dispatch(registerExternalUser(dataToSend));
        setShowVerification(true);
    };

    const handleVerification = async (e) => {
        e.preventDefault();
        dispatch(validateExternalUser({
            Mail: formData.email,
            Password: verificationCode
        }));
    };

    const resetForm = () => {
        setFormData({
            nombre: '',
            apellido: '',
            email: '',
            tipoDocumento: '',
            numeroDocumento: '',
            cargosExternos: [{
                cargo: '',
                entidad: {
                    nombre: '',
                    cuit: '',
                    rubro: '',
                    pais: '',
                    provincia: '',
                    sitioWeb: '',
                    emailContacto: '',
                    telefonoContacto: ''
                }
            }]
        });
        setHasCompany(false);
        setShowVerification(false);
        setVerificationCode('');
    };

    const handleHide = () => {
        resetForm();
        onHide();
    };

    return (
        <Modal show={show} onHide={handleHide} aria-labelledby="contained-modal-title-vcenter" centered className='modalSignup' id="ContainerSign">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className='registrarse'>
                    REGISTRATE
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : showVerification ? (
                    <div id="ContainerVerification">
                        <Alert variant="info" className="mb-4">
                            Se ha enviado un código de verificación a tu email. Ingresa el código para completar el registro.
                        </Alert>
                        {error && (
                            <Alert variant="danger" className="mb-4">
                                {error}
                            </Alert>
                        )}
                        <Form onSubmit={handleVerification} className="d-flex flex-column">
                            <Form.Group controlId="verificationCode" className="mb-3">
                                <Form.Control
                                    className='inputVerification'
                                    type="text"
                                    placeholder="Código de verificación"
                                    required
                                    value={verificationCode}
                                    onChange={e => setVerificationCode(e.target.value)}
                                />
                            </Form.Group>
                            <div className="d-flex justify-content-center mt-3">
                                <Button variant="primary" type="submit" id="ButtonVerify">
                                    Verificar
                                </Button>
                            </div>
                        </Form>
                    </div>
                ) : (
                    <div id="ContainerSignup">
                        {error && (
                            <Alert variant="danger" className="mb-4">
                                {error}
                            </Alert>
                        )}
                        <p className="mb-4" style={{ fontFamily: 'Montserrat', fontSize: '14px' }}>
                            Si no contás con una cuenta en UAI.Microcredenciales, podés registrarte completando el siguiente formulario. <br/>
                            Una vez verificada tu cuenta, podrás continuar con la gestión de Microcredenciales.
                        </p>
                        
                        <Form onSubmit={handleSubmit} className="d-flex flex-column">
                            <Row>
                                <Col md={6}>
                                    <Form.Group controlId="nombre" className="mb-3">
                                        <Form.Control
                                            className='inputSignup'
                                            type="text"
                                            placeholder="Nombre"
                                            name="nombre"
                                            required
                                            value={formData.nombre}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="apellido" className="mb-3">
                                        <Form.Control
                                            className='inputSignup'
                                            type="text"
                                            placeholder="Apellido"
                                            name="apellido"
                                            required
                                            value={formData.apellido}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group controlId="email" className="mb-3">
                                <Form.Control
                                    className='inputSignup'
                                    type="email"
                                    placeholder="Email"
                                    name="email"
                                    required
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                            </Form.Group>
                            <Row>
                                <Col md={6}>
                                    <Form.Group controlId="tipoDocumento" className="mb-3">
                                        <Form.Select
                                            className='inputSignup'
                                            name="tipoDocumento"
                                            required
                                            value={formData.tipoDocumento}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Tipo de documento</option>
                                            <option value="DNI">DNI</option>
                                            <option value="Pasaporte">Pasaporte</option>
                                            <option value="Otro">Otro</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="numeroDocumento" className="mb-3">
                                        <Form.Control
                                            className='inputSignup'
                                            type="text"
                                            placeholder="Número de Documento"
                                            name="numeroDocumento"
                                            required
                                            value={formData.numeroDocumento}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group controlId="hasCompany" className="mb-3">
                                <Form.Check
                                    type="switch"
                                    id="hasCompanySwitch"
                                    label="¿Tiene una empresa asociada?"
                                    checked={hasCompany}
                                    onChange={e => setHasCompany(e.target.checked)}
                                />
                            </Form.Group>
                            {hasCompany && (
                                <>
                                    <Form.Group controlId="cargo" className="mb-3">
                                        <Form.Control
                                            className='inputSignup'
                                            type="text"
                                            placeholder="Cargo"
                                            name="cargo"
                                            required
                                            value={formData.cargosExternos[0].cargo}
                                            onChange={handleCargoChange}
                                        />
                                    </Form.Group>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="entidadNombre" className="mb-3">
                                                <Form.Control
                                                    className='inputSignup'
                                                    type="text"
                                                    placeholder="Nombre de la Empresa"
                                                    name="nombre"
                                                    required
                                                    value={formData.cargosExternos[0].entidad.nombre}
                                                    onChange={handleEntidadChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="cuit" className="mb-3">
                                                <Form.Control
                                                    className='inputSignup'
                                                    type="text"
                                                    placeholder="CUIT"
                                                    name="cuit"
                                                    required
                                                    value={formData.cargosExternos[0].entidad.cuit}
                                                    onChange={handleEntidadChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="rubro" className="mb-3">
                                                <Form.Control
                                                    className='inputSignup'
                                                    type="text"
                                                    placeholder="Rubro"
                                                    name="rubro"
                                                    required
                                                    value={formData.cargosExternos[0].entidad.rubro}
                                                    onChange={handleEntidadChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="pais" className="mb-3">
                                                <Form.Control
                                                    className='inputSignup'
                                                    type="text"
                                                    placeholder="País"
                                                    name="pais"
                                                    required
                                                    value={formData.cargosExternos[0].entidad.pais}
                                                    onChange={handleEntidadChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="provincia" className="mb-3">
                                                <Form.Control
                                                    className='inputSignup'
                                                    type="text"
                                                    placeholder="Provincia"
                                                    name="provincia"
                                                    required
                                                    value={formData.cargosExternos[0].entidad.provincia}
                                                    onChange={handleEntidadChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="sitioWeb" className="mb-3">
                                                <Form.Control
                                                    className='inputSignup'
                                                    type="url"
                                                    placeholder="Sitio Web"
                                                    name="sitioWeb"
                                                    value={formData.cargosExternos[0].entidad.sitioWeb}
                                                    onChange={handleEntidadChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="emailContacto" className="mb-3">
                                                <Form.Control
                                                    className='inputSignup'
                                                    type="email"
                                                    placeholder="Email de Contacto"
                                                    name="emailContacto"
                                                    value={formData.cargosExternos[0].entidad.emailContacto}
                                                    onChange={handleEntidadChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="telefonoContacto" className="mb-3">
                                                <Form.Control
                                                    className='inputSignup'
                                                    type="tel"
                                                    placeholder="Teléfono de Contacto"
                                                    name="telefonoContacto"
                                                    value={formData.cargosExternos[0].entidad.telefonoContacto}
                                                    onChange={handleEntidadChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>
                            )}
                            <div className="d-flex justify-content-center mt-3">
                                <Button variant="primary" type="submit" id="ButtonSignup">
                                    Registrarse
                                </Button>
                            </div>
                        </Form>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default SignupModal;